export default __webpack_public_path__ + "static/media/Luca Colombo.2c9b7076.jpg";